/**
 * User-facing screens for overlay locales (ja/zh-CN/zh-TW/hi/th/id).
 * Merged last in getScreenUiOverlay so English leftovers in overlay*.js are replaced.
 * Excludes business dashboard / admin (bizCreator, admin.*).
 */

const CATALOG_JA = {
  catalogDetail: {
    main: {
      pageTitle: '商品',
      notFoundTitle: '商品が見つかりません',
      notFoundHint: '未公開または非公開の商品の可能性があります。',
      paidConfirmedToast: '{mode}決済が完了しました。予約を受け付けました。',
      durationHoursFormat: '{hours}時間',
      previewBanner: '未公開プレビュー — お客様にはまだ表示されません。',
      noPackageAvailable: '予約可能なパッケージがありません。チャットでお問い合わせください。',
      requestSentToast: '予約リクエストを受け付けました。事業者とのやり取り後に確定します。',
      instantBookBadge: '即時確定',
      partnerConfirmBadge: '事業者確認',
      pickupBadge: '送迎',
      freeCancelBadge: '無料キャンセル',
      noRefundBadge: 'キャンセル不可',
      discountSectionTitle: '割引情報',
      priceFromTo: '定価 {list} → 割引価格 {base}',
      discountAppliedLabel: '{rate}%割引適用',
      serviceInfoTitle: 'サービス情報',
      durationLabel: '所要時間: {duration}',
      comboSectionTitle: '🎁 コンボ構成',
      comboTotalDuration: '合計所要時間: {duration}',
      descriptionTitle: '詳細説明',
      businessInfoTitle: '事業者情報',
      businessInfoHint: '下部のボタンからチャットで問い合わせできます。',
      businessFallback: '事業者',
      labelPreview: '公開後に予約可能',
      labelConsult: '相談を申し込む',
      labelBook: '今すぐ予約',
      menuFallback: 'メニュー',
    },
    reviews: {
      sectionTitle: 'レビュー',
      empty: 'まだレビューがありません',
      countSuffix: 'レビュー{count}件',
      loadMore: 'レビューをもっと見る',
      anonymous: '匿名',
    },
  },
  bookingSheet: {
    title: '予約する',
    dateLabel: '日付',
    dateListAria: '予約日',
    timeLabel: '時間',
    noTimeSlotHint: 'この日は予約可能な時間がありません。別の日を選んでください。',
    timeDiscountFallback: '時間帯割引',
    timeDiscountBadge: '🔥 {label} · {percent}%割引適用',
    adultsLabel: '大人',
    childrenLabel: '子供',
    totalLabel: '合計',
    payMethodLabel: '支払い方法',
    depositLabel: '予約金',
    fullLabel: '全額',
    requestWithoutPayBtn: '支払いなしで予約リクエスト',
    processingLabel: '処理中…',
    requestBtn: '予約リクエストする',
    closeBtn: '閉じる',
    selectTimeToast: '予約時間を選択してください。',
    slotsLeft: '残り{count}席',
    almostFull: '締切間近',
    cardInfoLabel: 'カード情報',
    testCardHint: 'テスト: 成功 4242…4242 · 失敗 4000…0002',
    payBtn: '{label}を支払う',
    payProcessing: '決済処理中…',
    stripeLoading: '決済システムを読み込み中です。しばらくしてから再度お試しください。',
    bookingFailToast: '予約の送信に失敗しました。',
    noPaymentServer: '決済サーバーに接続できません。',
    loginRequired: 'ログインが必要です。',
    payPrepFail: '決済の準備に失敗しました。',
    cardPayFail: 'カード決済に失敗しました。',
    payNotCompleted: '決済が完了していません。',
    payError: '決済中にエラーが発生しました。',
  },
  bookingBar: { chatInquiry: 'チャットで問い合わせ', consultRequest: '相談を申し込む' },
};

const TRADE_JA = {
  search: {
    placeholder: '出品・投稿・求人を検索',
    hint: 'マーケット・コミュニティ・求人をまとめて検索します。',
    empty: '結果がありません。',
    products: 'マーケット',
    posts: 'コミュニティ',
    jobs: '求人',
    tabAll: 'すべて',
    tabProducts: '出品',
    tabPosts: '投稿',
    tabJobs: '求人',
    jobHireBadge: '求人',
    jobSeekBadge: '求職',
    jobsMoreInTab: '求人タブでさらに表示',
    recentTitle: '最近の検索',
    popularTitle: '人気',
  },
  productDetail: {
    back: '戻る',
    more: 'その他',
    mannerTemp: 'マナー温度',
    chat: 'チャット',
    chatNoSeller: '会員の出品のみチャットできます。',
    chatOwnProduct: '自分の出品です。',
    chatOpenFailed: 'チャットを開始できませんでした。',
    reportScam: '詐欺を報告',
    reportNeedDb: 'サーバーに保存された出品のみ報告できます。',
    like: 'いいね',
    likeOn: 'いいね解除',
    likeOff: 'いいね',
    sliderLabel: '商品写真',
    views: '{count}回閲覧',
    safePaymentSoon: 'アプリ内決済は近日公開',
  },
  postDetail: {
    back: '戻る',
    more: 'その他',
    report: '報告',
    comments: 'コメント',
    commentPlaceholder: 'コメントを書く…',
    post: '投稿',
    likes: 'いいね',
    likeOn: 'いいね解除',
    likeOff: 'いいね',
    commentEmpty: 'コメントを入力してください。',
    commentSent: 'コメントを投稿しました。',
    translate: '翻訳',
    showOriginal: '原文を表示',
    translateFailed: '翻訳できません。',
    translateBusy: '翻訳中…',
  },
  write: {
    tradeTitle: '新規出品',
    done: '完了',
    close: '閉じる',
    communityTitle: '近所の投稿',
    submit: '投稿',
    photos: '写真',
    title: 'タイトル',
    category: 'カテゴリ',
    price: '価格',
    freeShare: '無料譲渡',
    body: '説明',
    bodyPlaceholder: '近所の方と取引しましょう',
    regionLine: '取引エリア',
    regionArea: 'エリア',
    communityBodyPh: '近所のヒントを共有',
    optionalPhoto: '写真（任意）',
    regionUnset: '未設定',
    regionAll: '全エリア',
    titlePlaceholder: 'タイトルを入力',
    pricePlaceholder: '価格を入力',
    saving: '投稿中…',
    saved: '保存しました。',
    saveFailed: '保存できませんでした。',
    needTitle: 'タイトルを入力してください。',
    needTitleBody: 'タイトルと本文を入力してください。',
    submitCta: '出品する',
    justNow: 'たった今',
    imageOptimizing: '画像を最適化中…',
  },
  jobs: {
    title: '求人',
    tabHire: '求人',
    tabSeek: '求職',
    writeFab: '書く',
    writeHire: '求人を出す',
    writeSeek: '求職プロフィール',
    needTitle: 'タイトルを入力してください。',
    saved: '投稿しました。',
    fieldTitle: 'タイトル / 会社・ニックネーム',
    fieldSalary: '給与 / 希望給',
    fieldRegion: '地域',
    fieldExtra: '詳細',
    fieldContact: '連絡先',
  },
  notificationCenter: {
    title: '通知',
    markAll: 'すべて既読',
    unread: '未読',
    loading: '通知を読み込み中…',
    emptyRemote: '通知はまだありません。',
  },
  share: {
    open: '共有',
    system: '共有方法…',
    copy: 'リンクをコピー',
    copied: 'リンクをコピーしました。',
    copyFailed: 'コピーできませんでした。',
  },
  creator: {
    pageTitle: 'クリエイター',
    onboarding: {
      title: 'クリエイター申請',
      desc: '来店を促すコンテンツを作り、訪問ごとに報酬を受け取ります。',
      nameLabel: '活動名',
      namePlaceholder: 'ニックネーム / チャンネル名',
      nameRequired: '活動名を入力してください。',
      prefillNote: 'プロフィールから入力しました。必要なら編集できます。',
      refetchBtn: 'プロフィールから再読込',
      bioLabel: '紹介',
      bioPlaceholder: '短い自己紹介',
      typeLabel: 'コンテンツの種類',
      cityLabel: '活動地域',
      followerLabel: 'フォロワー数',
      submitBtn: '申請する',
      submitted: '申請を受け付けました。審査後にお知らせします。',
      submitFail: '申請に失敗しました。',
      type: { video: '動画', photo: '写真', blog: 'ブログ', mixed: 'ミックス' },
    },
    pending: {
      title: '審査中です',
      desc: 'クリエイター申請を確認しています。承認後にお知らせします。',
    },
    qrLanding: {
      notFound: '無効なリンクです。',
      genericError: 'エラーが発生しました。もう一度お試しください。',
      viaCreator: '{name}さんの紹介です',
      showStaffHint: 'この画面をスタッフに見せてください',
    },
  },
};

const pack = (catalog, trade) => ({ ...catalog, ...trade });

export const USER_FACING_UI = {
  ja: pack(CATALOG_JA, TRADE_JA),
  'zh-CN': pack(
    {
      catalogDetail: {
        main: {
          pageTitle: '商品',
          notFoundTitle: '找不到商品',
          notFoundHint: '可能未发布或已设为不公开。',
          paidConfirmedToast: '{mode}支付完成，预约已提交。',
          durationHoursFormat: '{hours}小时',
          previewBanner: '未发布预览 — 顾客还看不到。',
          noPackageAvailable: '暂无可预约套餐，请通过聊天咨询。',
          requestSentToast: '预约请求已提交，与商家沟通后确认。',
          instantBookBadge: '立即确认',
          partnerConfirmBadge: '商家确认',
          pickupBadge: '接送',
          freeCancelBadge: '免费取消',
          noRefundBadge: '不可取消',
          discountSectionTitle: '优惠信息',
          priceFromTo: '原价 {list} → 优惠价 {base}',
          discountAppliedLabel: '已减{rate}%',
          serviceInfoTitle: '服务信息',
          durationLabel: '时长: {duration}',
          comboSectionTitle: '🎁 套餐内容',
          comboTotalDuration: '总时长: {duration}',
          descriptionTitle: '详细说明',
          businessInfoTitle: '商家信息',
          businessInfoHint: '可通过底部按钮直接聊天。',
          businessFallback: '商家',
          labelPreview: '发布后可预约',
          labelConsult: '申请咨询',
          labelBook: '立即预约',
          menuFallback: '菜单',
        },
        reviews: {
          sectionTitle: '评价',
          empty: '暂无评价',
          countSuffix: '{count}条评价',
          loadMore: '查看更多评价',
          anonymous: '匿名',
        },
      },
      bookingSheet: {
        title: '预约',
        dateLabel: '日期',
        dateListAria: '预约日期',
        timeLabel: '时间',
        noTimeSlotHint: '当天没有可预约时段，请换一天。',
        timeDiscountFallback: '时段优惠',
        timeDiscountBadge: '🔥 {label} · {percent}%优惠',
        adultsLabel: '成人',
        childrenLabel: '儿童',
        totalLabel: '合计',
        payMethodLabel: '支付方式',
        depositLabel: '订金',
        fullLabel: '全额',
        requestWithoutPayBtn: '无需支付，先提交预约',
        processingLabel: '处理中…',
        requestBtn: '提交预约',
        closeBtn: '关闭',
        selectTimeToast: '请选择预约时间。',
        slotsLeft: '剩余{count}位',
        almostFull: '即将满额',
        cardInfoLabel: '卡片信息',
        testCardHint: '测试卡：成功 4242… · 失败 4000…',
        payBtn: '支付{label}',
        payProcessing: '正在支付…',
        stripeLoading: '正在加载支付系统，请稍后重试。',
        bookingFailToast: '预约提交失败。',
        noPaymentServer: '无法连接支付服务器。',
        loginRequired: '需要登录。',
        payPrepFail: '支付准备失败。',
        cardPayFail: '银行卡支付失败。',
        payNotCompleted: '支付未完成。',
        payError: '支付出错。',
      },
      bookingBar: { chatInquiry: '聊天咨询', consultRequest: '申请咨询' },
    },
    {
      search: {
        placeholder: '搜索商品、帖子和招聘',
        hint: '同时搜索市集、社区和招聘。',
        empty: '没有结果。',
        products: '市集',
        posts: '社区',
        jobs: '招聘',
        tabAll: '全部',
        tabProducts: '商品',
        tabPosts: '帖子',
        tabJobs: '招聘',
        jobHireBadge: '招聘',
        jobSeekBadge: '求职',
        jobsMoreInTab: '打开招聘页查看更多',
        recentTitle: '最近搜索',
        popularTitle: '热门',
      },
      productDetail: {
        back: '返回', more: '更多', mannerTemp: '信用温度', chat: '聊天',
        chatNoSeller: '仅会员商品可聊天。', chatOwnProduct: '这是你自己的商品。',
        chatOpenFailed: '无法开始聊天。', reportScam: '举报诈骗',
        like: '喜欢', likeOn: '取消喜欢', likeOff: '喜欢', sliderLabel: '商品照片',
        views: '{count}次浏览', safePaymentSoon: '应用内支付即将推出',
      },
      postDetail: {
        back: '返回', more: '更多', report: '举报', comments: '评论',
        commentPlaceholder: '写评论…', post: '发布', likes: '赞',
        likeOn: '取消赞', likeOff: '赞', commentEmpty: '请输入评论。',
        commentSent: '评论已发布。', translate: '翻译', showOriginal: '显示原文',
        translateFailed: '无法翻译。', translateBusy: '翻译中…',
      },
      write: {
        tradeTitle: '发布商品', done: '完成', close: '关闭', communityTitle: '邻里帖子',
        submit: '发布', photos: '照片', title: '标题', category: '分类', price: '价格',
        freeShare: '免费赠送', body: '说明', bodyPlaceholder: '和附近邻居交易',
        regionLine: '交易地区', regionArea: '地区', communityBodyPh: '分享邻里贴士',
        optionalPhoto: '照片（可选）', regionUnset: '未设置', regionAll: '全部地区',
        titlePlaceholder: '输入标题', pricePlaceholder: '输入价格', saving: '发布中…',
        saved: '已保存。', saveFailed: '保存失败。', needTitle: '请输入标题。',
        needTitleBody: '请输入标题和正文。', submitCta: '发布商品', justNow: '刚刚',
        imageOptimizing: '正在优化图片…',
      },
      jobs: {
        title: '招聘', tabHire: '招聘', tabSeek: '求职', writeFab: '发布',
        writeHire: '发布招聘', writeSeek: '发布求职', needTitle: '请输入标题。',
        saved: '已发布。', fieldTitle: '标题 / 公司或昵称', fieldSalary: '薪资 / 期望薪资',
        fieldRegion: '地区', fieldExtra: '详情', fieldContact: '联系方式',
      },
      notificationCenter: {
        title: '通知', markAll: '全部已读', unread: '未读',
        loading: '正在加载通知…', emptyRemote: '暂无通知。',
      },
      share: { open: '分享', system: '分享到…', copy: '复制链接', copied: '已复制链接。', copyFailed: '无法复制。' },
      creator: {
        pageTitle: '创作者',
        onboarding: {
          title: '申请成为创作者',
          desc: '制作能带来到店的内容，按到店次数获得佣金。',
          nameLabel: '昵称', namePlaceholder: '昵称 / 频道名', nameRequired: '请输入昵称。',
          prefillNote: '已从个人资料填入，可自行修改。', refetchBtn: '重新读取资料',
          bioLabel: '简介', bioPlaceholder: '简短介绍', typeLabel: '内容类型',
          cityLabel: '活动城市', followerLabel: '粉丝数', submitBtn: '提交申请',
          submitted: '申请已提交，审核后通知你。', submitFail: '申请失败。',
          type: { video: '视频', photo: '照片', blog: '博客', mixed: '混合' },
        },
        pending: { title: '审核中', desc: '正在审核创作者申请，通过后会通知你。' },
        qrLanding: {
          notFound: '链接无效。', genericError: '出错了，请重试。',
          viaCreator: '你是通过 {name} 来的', showStaffHint: '请把此屏幕给店员看',
        },
      },
    },
  ),
  'zh-TW': pack(
    {
      catalogDetail: {
        main: {
          pageTitle: '商品',
          notFoundTitle: '找不到商品',
          notFoundHint: '可能尚未發布或設為不公開。',
          paidConfirmedToast: '{mode}付款完成，預約已送出。',
          durationHoursFormat: '{hours}小時',
          previewBanner: '未發布預覽 — 顧客還看不到。',
          noPackageAvailable: '暫無可預約套餐，請用聊天詢問。',
          requestSentToast: '預約請求已送出，與商家溝通後確認。',
          instantBookBadge: '立即確認',
          partnerConfirmBadge: '商家確認',
          pickupBadge: '接送',
          freeCancelBadge: '免費取消',
          noRefundBadge: '不可取消',
          discountSectionTitle: '優惠資訊',
          priceFromTo: '原價 {list} → 優惠價 {base}',
          discountAppliedLabel: '已折{rate}%',
          serviceInfoTitle: '服務資訊',
          durationLabel: '時長: {duration}',
          comboSectionTitle: '🎁 套餐內容',
          comboTotalDuration: '總時長: {duration}',
          descriptionTitle: '詳細說明',
          businessInfoTitle: '商家資訊',
          businessInfoHint: '可用底部按鈕直接聊天。',
          businessFallback: '商家',
          labelPreview: '發布後可預約',
          labelConsult: '申請諮詢',
          labelBook: '立即預約',
          menuFallback: '菜單',
        },
        reviews: {
          sectionTitle: '評價',
          empty: '尚無評價',
          countSuffix: '{count}則評價',
          loadMore: '查看更多評價',
          anonymous: '匿名',
        },
      },
      bookingSheet: {
        title: '預約',
        dateLabel: '日期',
        dateListAria: '預約日期',
        timeLabel: '時間',
        noTimeSlotHint: '當天沒有可預約時段，請換一天。',
        timeDiscountFallback: '時段優惠',
        timeDiscountBadge: '🔥 {label} · {percent}%優惠',
        adultsLabel: '成人',
        childrenLabel: '兒童',
        totalLabel: '合計',
        payMethodLabel: '付款方式',
        depositLabel: '訂金',
        fullLabel: '全額',
        requestWithoutPayBtn: '先送出預約（不付款）',
        processingLabel: '處理中…',
        requestBtn: '送出預約',
        closeBtn: '關閉',
        selectTimeToast: '請選擇預約時間。',
        slotsLeft: '剩餘{count}位',
        almostFull: '即將額滿',
        cardInfoLabel: '卡片資訊',
        testCardHint: '測試卡：成功 4242… · 失敗 4000…',
        payBtn: '支付{label}',
        payProcessing: '正在付款…',
        stripeLoading: '正在載入付款系統，請稍後再試。',
        bookingFailToast: '預約送出失敗。',
        noPaymentServer: '無法連線付款伺服器。',
        loginRequired: '需要登入。',
        payPrepFail: '付款準備失敗。',
        cardPayFail: '卡片付款失敗。',
        payNotCompleted: '付款未完成。',
        payError: '付款發生錯誤。',
      },
      bookingBar: { chatInquiry: '聊天詢問', consultRequest: '申請諮詢' },
    },
    {
      search: {
        placeholder: '搜尋商品、貼文與職缺',
        hint: '一次搜尋市集、社群與求職。',
        empty: '沒有結果。',
        products: '市集',
        posts: '社群',
        jobs: '職缺',
        tabAll: '全部',
        tabProducts: '商品',
        tabPosts: '貼文',
        tabJobs: '職缺',
        jobHireBadge: '徵才',
        jobSeekBadge: '求職',
        jobsMoreInTab: '到職缺分頁看更多',
        recentTitle: '最近搜尋',
        popularTitle: '熱門',
      },
      productDetail: {
        back: '返回', more: '更多', mannerTemp: '信用溫度', chat: '聊天',
        chatNoSeller: '僅會員商品可聊天。', chatOwnProduct: '這是你自己的商品。',
        chatOpenFailed: '無法開始聊天。', reportScam: '檢舉詐騙',
        like: '喜歡', likeOn: '取消喜歡', likeOff: '喜歡', sliderLabel: '商品照片',
        views: '{count}次瀏覽', safePaymentSoon: '應用內付款即將推出',
      },
      postDetail: {
        back: '返回', more: '更多', report: '檢舉', comments: '留言',
        commentPlaceholder: '寫留言…', post: '發布', likes: '讚',
        likeOn: '收回讚', likeOff: '讚', commentEmpty: '請輸入留言。',
        commentSent: '留言已發布。', translate: '翻譯', showOriginal: '顯示原文',
        translateFailed: '無法翻譯。', translateBusy: '翻譯中…',
      },
      write: {
        tradeTitle: '刊登商品', done: '完成', close: '關閉', communityTitle: '鄰里貼文',
        submit: '發布', photos: '照片', title: '標題', category: '分類', price: '價格',
        freeShare: '免費贈送', body: '說明', bodyPlaceholder: '和附近鄰居交易',
        regionLine: '交易地區', regionArea: '地區', communityBodyPh: '分享鄰里小知識',
        optionalPhoto: '照片（選填）', regionUnset: '未設定', regionAll: '全部地區',
        titlePlaceholder: '輸入標題', pricePlaceholder: '輸入價格', saving: '發布中…',
        saved: '已儲存。', saveFailed: '儲存失敗。', needTitle: '請輸入標題。',
        needTitleBody: '請輸入標題與內文。', submitCta: '刊登商品', justNow: '剛剛',
        imageOptimizing: '正在最佳化圖片…',
      },
      jobs: {
        title: '職缺', tabHire: '徵才', tabSeek: '求職', writeFab: '發布',
        writeHire: '刊登徵才', writeSeek: '刊登求職', needTitle: '請輸入標題。',
        saved: '已發布。', fieldTitle: '標題 / 公司或暱稱', fieldSalary: '薪資 / 期望薪資',
        fieldRegion: '地區', fieldExtra: '詳情', fieldContact: '聯絡方式',
      },
      notificationCenter: {
        title: '通知', markAll: '全部已讀', unread: '未讀',
        loading: '正在載入通知…', emptyRemote: '尚無通知。',
      },
      share: { open: '分享', system: '分享到…', copy: '複製連結', copied: '已複製連結。', copyFailed: '無法複製。' },
      creator: {
        pageTitle: '創作者',
        onboarding: {
          title: '申請成為創作者',
          desc: '製作能帶來到店的內容，按到店次數獲得佣金。',
          nameLabel: '暱稱', namePlaceholder: '暱稱 / 頻道名', nameRequired: '請輸入暱稱。',
          prefillNote: '已從個人資料填入，可自行修改。', refetchBtn: '重新讀取資料',
          bioLabel: '簡介', bioPlaceholder: '簡短介紹', typeLabel: '內容類型',
          cityLabel: '活動城市', followerLabel: '粉絲數', submitBtn: '送出申請',
          submitted: '申請已送出，審核後通知你。', submitFail: '申請失敗。',
          type: { video: '影片', photo: '照片', blog: '部落格', mixed: '混合' },
        },
        pending: { title: '審核中', desc: '正在審核創作者申請，通過後會通知你。' },
        qrLanding: {
          notFound: '連結無效。', genericError: '發生錯誤，請再試一次。',
          viaCreator: '你是透過 {name} 前來', showStaffHint: '請把此畫面給店員看',
        },
      },
    },
  ),
  hi: pack(
    {
      catalogDetail: {
        main: {
          pageTitle: 'उत्पाद',
          notFoundTitle: 'उत्पाद नहीं मिला',
          notFoundHint: 'यह अप्रकाशित या निजी हो सकता है।',
          paidConfirmedToast: '{mode} भुगतान पूरा। बुकिंग भेज दी गई।',
          durationHoursFormat: '{hours} घंटे',
          previewBanner: 'अप्रकाशित पूर्वावलोकन — ग्राहकों को अभी नहीं दिखेगा।',
          noPackageAvailable: 'कोई बुक करने योग्य पैकेज नहीं। चैट से संपर्क करें।',
          requestSentToast: 'बुकिंग अनुरोध भेज दिया गया। मेज़बान से बात के बाद पुष्टि होगी।',
          instantBookBadge: 'तुरंत पुष्टि',
          partnerConfirmBadge: 'मेज़बान पुष्टि',
          pickupBadge: 'पिकअप',
          freeCancelBadge: 'मुफ़्त रद्द',
          noRefundBadge: 'अप्रतिदेय',
          discountSectionTitle: 'छूट',
          priceFromTo: 'मूल {list} → छूट {base}',
          discountAppliedLabel: '{rate}% छूट लागू',
          serviceInfoTitle: 'सेवा जानकारी',
          durationLabel: 'अवधि: {duration}',
          comboSectionTitle: '🎁 कॉम्बो',
          comboTotalDuration: 'कुल अवधि: {duration}',
          descriptionTitle: 'विवरण',
          businessInfoTitle: 'मेज़बान के बारे में',
          businessInfoHint: 'नीचे बटन से सीधे चैट करें।',
          businessFallback: 'व्यवसाय',
          labelPreview: 'प्रकाशित होने के बाद बुक करें',
          labelConsult: 'परामर्श माँगें',
          labelBook: 'अभी बुक करें',
          menuFallback: 'मेनू',
        },
        reviews: {
          sectionTitle: 'समीक्षाएँ',
          empty: 'अभी कोई समीक्षा नहीं',
          countSuffix: '{count} समीक्षाएँ',
          loadMore: 'और समीक्षाएँ',
          anonymous: 'अनाम',
        },
      },
      bookingSheet: {
        title: 'बुक करें',
        dateLabel: 'तारीख',
        dateListAria: 'बुकिंग तारीख',
        timeLabel: 'समय',
        noTimeSlotHint: 'इस दिन स्लॉट नहीं हैं। दूसरी तारीख चुनें।',
        timeDiscountFallback: 'समय छूट',
        timeDiscountBadge: '🔥 {label} · {percent}% छूट',
        adultsLabel: 'वयस्क',
        childrenLabel: ' बच्चे',
        totalLabel: 'कुल',
        payMethodLabel: 'भुगतान तरीका',
        depositLabel: 'जमा',
        fullLabel: 'पूरी राशि',
        requestWithoutPayBtn: 'बिना भुगतान अनुरोध',
        processingLabel: 'प्रोसेस हो रहा…',
        requestBtn: 'बुकिंग अनुरोध',
        closeBtn: 'बंद करें',
        selectTimeToast: 'कृपया समय चुनें।',
        slotsLeft: '{count} सीटें बचीं',
        almostFull: 'लगभग भर गया',
        cardInfoLabel: 'कार्ड जानकारी',
        testCardHint: 'टेस्ट: सफल 4242… · असफल 4000…',
        payBtn: '{label} चुकाएँ',
        payProcessing: 'भुगतान हो रहा…',
        stripeLoading: 'भुगतान सिस्टम लोड हो रहा है। बाद में कोशिश करें।',
        bookingFailToast: 'बुकिंग नहीं भेजी जा सकी।',
        noPaymentServer: 'भुगतान सर्वर नहीं जुड़ा।',
        loginRequired: 'लॉगिन ज़रूरी है।',
        payPrepFail: 'भुगतान तैयार नहीं हुआ।',
        cardPayFail: 'कार्ड भुगतान असफल।',
        payNotCompleted: 'भुगतान पूरा नहीं हुआ।',
        payError: 'भुगतान में त्रुटि।',
      },
      bookingBar: { chatInquiry: 'चैट से पूछें', consultRequest: 'परामर्श माँगें' },
    },
    {
      search: {
        placeholder: 'लिस्टिंग, पोस्ट और नौकरियाँ खोजें',
        hint: 'बाज़ार, समुदाय और नौकरियाँ एक साथ खोजें।',
        empty: 'कोई परिणाम नहीं।',
        products: 'बाज़ार',
        posts: 'समुदाय',
        jobs: 'नौकरियाँ',
        tabAll: 'सभी',
        tabProducts: 'लिस्टिंग',
        tabPosts: 'पोस्ट',
        tabJobs: 'नौकरियाँ',
        jobHireBadge: 'भर्ती',
        jobSeekBadge: 'नौकरी खोज',
        jobsMoreInTab: 'और नौकरियाँ टैब में देखें',
        recentTitle: 'हाल की खोज',
        popularTitle: 'लोकप्रिय',
      },
      productDetail: {
        back: 'वापस', more: 'और', mannerTemp: 'शिष्टता स्कोर', chat: 'चैट',
        chatNoSeller: 'केवल सदस्य लिस्टिंग पर चैट।', chatOwnProduct: 'यह आपकी लिस्टिंग है।',
        chatOpenFailed: 'चैट शुरू नहीं हो सकी।', reportScam: 'धोखाधड़ी रिपोर्ट',
        like: 'पसंद', likeOn: 'पसंद हटाएँ', likeOff: 'पसंद', sliderLabel: 'उत्पाद फ़ोटो',
        views: '{count} व्यू', safePaymentSoon: 'इन-ऐप भुगतान जल्द',
      },
      postDetail: {
        back: 'वापस', more: 'और', report: 'रिपोर्ट', comments: 'टिप्पणियाँ',
        commentPlaceholder: 'टिप्पणी लिखें…', post: 'पोस्ट', likes: 'पसंद',
        likeOn: 'पसंद हटाएँ', likeOff: 'पसंद', commentEmpty: 'टिप्पणी लिखें।',
        commentSent: 'टिप्पणी पोस्ट हुई।', translate: 'अनुवाद', showOriginal: 'मूल दिखाएँ',
        translateFailed: 'अनुवाद नहीं हो सका।', translateBusy: 'अनुवाद हो रहा…',
      },
      write: {
        tradeTitle: 'नई लिस्टिंग', done: 'हो गया', close: 'बंद', communityTitle: 'पड़ोस पोस्ट',
        submit: 'पोस्ट', photos: 'फ़ोटो', title: 'शीर्षक', category: 'श्रेणी', price: 'कीमत',
        freeShare: 'मुफ़्त दें', body: 'विवरण', bodyPlaceholder: 'पास के पड़ोसियों से लेन-देन',
        regionLine: 'क्षेत्र', regionArea: 'इलाका', communityBodyPh: 'पड़ोस टिप्स साझा करें',
        optionalPhoto: 'फ़ोटो (वैकल्पिक)', regionUnset: 'सेट नहीं', regionAll: 'सभी क्षेत्र',
        titlePlaceholder: 'शीर्षक लिखें', pricePlaceholder: 'कीमत लिखें', saving: 'पोस्ट हो रहा…',
        saved: 'सेव हो गया।', saveFailed: 'सेव नहीं हुआ।', needTitle: 'शीर्षक लिखें।',
        needTitleBody: 'शीर्षक और विवरण लिखें।', submitCta: 'लिस्टिंग पोस्ट करें', justNow: 'अभी',
        imageOptimizing: 'फ़ोटो अनुकूलित हो रही…',
      },
      jobs: {
        title: 'नौकरियाँ', tabHire: 'भर्ती', tabSeek: 'नौकरी खोज', writeFab: 'लिखें',
        writeHire: 'नौकरी पोस्ट', writeSeek: 'प्रोफ़ाइल पोस्ट', needTitle: 'शीर्षक लिखें।',
        saved: 'पोस्ट हो गया।', fieldTitle: 'शीर्षक / कंपनी या निकनेम', fieldSalary: 'वेतन',
        fieldRegion: 'क्षेत्र', fieldExtra: 'विवरण', fieldContact: 'संपर्क',
      },
      notificationCenter: {
        title: 'सूचनाएँ', markAll: 'सभी पढ़ीं', unread: 'अपठित',
        loading: 'सूचनाएँ लोड…', emptyRemote: 'अभी कोई सूचना नहीं।',
      },
      share: { open: 'साझा करें', system: 'इससे साझा…', copy: 'लिंक कॉपी', copied: 'लिंक कॉपी हुआ।', copyFailed: 'कॉपी नहीं हुआ।' },
      creator: {
        pageTitle: 'क्रिएटर',
        onboarding: {
          title: 'क्रिएटर बनें',
          desc: 'विज़िट बढ़ाने वाला कंटेंट बनाएँ और हर विज़िट पर कमीशन पाएँ।',
          nameLabel: 'नाम', namePlaceholder: 'निकनेम / चैनल', nameRequired: 'नाम लिखें।',
          prefillNote: 'प्रोफ़ाइल से भरा गया। बदल सकते हैं।', refetchBtn: 'प्रोफ़ाइल से फिर लें',
          bioLabel: 'परिचय', bioPlaceholder: 'छोटा परिचय', typeLabel: 'कंटेंट प्रकार',
          cityLabel: 'शहर', followerLabel: 'फ़ॉलोअर', submitBtn: 'आवेदन',
          submitted: 'आवेदन भेज दिया। समीक्षा के बाद बताएँगे।', submitFail: 'आवेदन असफल।',
          type: { video: 'वीडियो', photo: 'फ़ोटो', blog: 'ब्लॉग', mixed: 'मिश्रित' },
        },
        pending: { title: 'समीक्षा में', desc: 'आवेदन जाँच रहे हैं। स्वीकृति पर बताएँगे।' },
        qrLanding: {
          notFound: 'लिंक अमान्य है।', genericError: 'कुछ गलत हुआ। फिर कोशिश करें।',
          viaCreator: 'आप {name} के ज़रिए आए', showStaffHint: 'यह स्क्रीन स्टाफ़ को दिखाएँ',
        },
      },
    },
  ),
  th: pack(
    {
      catalogDetail: {
        main: {
          pageTitle: 'สินค้า',
          notFoundTitle: 'ไม่พบสินค้า',
          notFoundHint: 'อาจยังไม่เผยแพร่หรือเป็นส่วนตัว',
          paidConfirmedToast: 'ชำระ {mode} แล้ว ส่งคำขอจองแล้ว',
          durationHoursFormat: '{hours} ชม.',
          previewBanner: 'ตัวอย่างที่ยังไม่เผยแพร่ — ลูกค้ายังมองไม่เห็น',
          noPackageAvailable: 'ไม่มีแพ็กเกจให้จอง โปรดคุยผ่านแชท',
          requestSentToast: 'ส่งคำขอจองแล้ว จะยืนยันหลังคุยกับร้าน',
          instantBookBadge: 'ยืนยันทันที',
          partnerConfirmBadge: 'ร้านยืนยัน',
          pickupBadge: 'รับส่ง',
          freeCancelBadge: 'ยกเลิกฟรี',
          noRefundBadge: 'ไม่คืนเงิน',
          discountSectionTitle: 'ส่วนลด',
          priceFromTo: 'ราคาเต็ม {list} → ลดเหลือ {base}',
          discountAppliedLabel: 'ลด {rate}%',
          serviceInfoTitle: 'ข้อมูลบริการ',
          durationLabel: 'ระยะเวลา: {duration}',
          comboSectionTitle: '🎁 ชุดคอมโบ',
          comboTotalDuration: 'เวลารวม: {duration}',
          descriptionTitle: 'รายละเอียด',
          businessInfoTitle: 'ข้อมูลร้าน',
          businessInfoHint: 'คุยกับร้านได้จากปุ่มด้านล่าง',
          businessFallback: 'ร้านค้า',
          labelPreview: 'จองได้หลังเผยแพร่',
          labelConsult: 'ขอคำปรึกษา',
          labelBook: 'จองเลย',
          menuFallback: 'เมนู',
        },
        reviews: {
          sectionTitle: 'รีวิว',
          empty: 'ยังไม่มีรีวิว',
          countSuffix: '{count} รีวิว',
          loadMore: 'ดูรีวิวเพิ่ม',
          anonymous: 'ไม่ระบุชื่อ',
        },
      },
      bookingSheet: {
        title: 'จอง',
        dateLabel: 'วันที่',
        dateListAria: 'วันที่จอง',
        timeLabel: 'เวลา',
        noTimeSlotHint: 'วันนี้ไม่มีคิวว่าง เลือกวันอื่น',
        timeDiscountFallback: 'ส่วนลดตามช่วงเวลา',
        timeDiscountBadge: '🔥 {label} · ลด {percent}%',
        adultsLabel: 'ผู้ใหญ่',
        childrenLabel: 'เด็ก',
        totalLabel: 'รวม',
        payMethodLabel: 'วิธีชำระ',
        depositLabel: 'มัดจำ',
        fullLabel: 'เต็มจำนวน',
        requestWithoutPayBtn: 'ส่งคำขอโดยไม่ชำระ',
        processingLabel: 'กำลังดำเนินการ…',
        requestBtn: 'ส่งคำขอจอง',
        closeBtn: 'ปิด',
        selectTimeToast: 'กรุณาเลือกเวลา',
        slotsLeft: 'เหลือ {count} ที่',
        almostFull: 'ใกล้เต็ม',
        cardInfoLabel: 'ข้อมูลบัตร',
        testCardHint: 'ทดสอบ: สำเร็จ 4242… · ล้มเหลว 4000…',
        payBtn: 'ชำระ {label}',
        payProcessing: 'กำลังชำระ…',
        stripeLoading: 'กำลังโหลดระบบชำระเงิน ลองใหม่ภายหลัง',
        bookingFailToast: 'ส่งคำขอจองไม่สำเร็จ',
        noPaymentServer: 'ต่อเซิร์ฟเวอร์ชำระเงินไม่ได้',
        loginRequired: 'ต้องเข้าสู่ระบบ',
        payPrepFail: 'เตรียมการชำระไม่สำเร็จ',
        cardPayFail: 'ชำระบัตรไม่สำเร็จ',
        payNotCompleted: 'ยังชำระไม่เสร็จ',
        payError: 'เกิดข้อผิดพลาดขณะชำระ',
      },
      bookingBar: { chatInquiry: 'สอบถามทางแชท', consultRequest: 'ขอคำปรึกษา' },
    },
    {
      search: {
        placeholder: 'ค้นหาสินค้า โพสต์ และงาน',
        hint: 'ค้นหาตลาด ชุมชน และงานพร้อมกัน',
        empty: 'ไม่พบผลลัพธ์',
        products: 'ตลาด',
        posts: 'ชุมชน',
        jobs: 'งาน',
        tabAll: 'ทั้งหมด',
        tabProducts: 'ประกาศ',
        tabPosts: 'โพสต์',
        tabJobs: 'งาน',
        jobHireBadge: 'รับสมัคร',
        jobSeekBadge: 'หางาน',
        jobsMoreInTab: 'ดูงานเพิ่มในแท็บงาน',
        recentTitle: 'ค้นหาล่าสุด',
        popularTitle: 'ยอดนิยม',
      },
      productDetail: {
        back: 'กลับ', more: 'เพิ่มเติม', mannerTemp: 'คะแนนมารยาท', chat: 'แชท',
        chatNoSeller: 'แชทได้เฉพาะประกาศของสมาชิก', chatOwnProduct: 'นี่คือประกาศของคุณ',
        chatOpenFailed: 'เริ่มแชทไม่ได้', reportScam: 'รายงานโกง',
        like: 'ถูกใจ', likeOn: 'เลิกถูกใจ', likeOff: 'ถูกใจ', sliderLabel: 'รูปสินค้า',
        views: 'ดู {count} ครั้ง', safePaymentSoon: 'ชำระในแอปเร็วๆ นี้',
      },
      postDetail: {
        back: 'กลับ', more: 'เพิ่มเติม', report: 'รายงาน', comments: 'ความคิดเห็น',
        commentPlaceholder: 'เขียนความคิดเห็น…', post: 'โพสต์', likes: 'ถูกใจ',
        likeOn: 'เลิกถูกใจ', likeOff: 'ถูกใจ', commentEmpty: 'กรอกความคิดเห็น',
        commentSent: 'โพสต์ความคิดเห็นแล้ว', translate: 'แปล', showOriginal: 'ดูต้นฉบับ',
        translateFailed: 'แปลไม่ได้', translateBusy: 'กำลังแปล…',
      },
      write: {
        tradeTitle: 'ลงประกาศใหม่', done: 'เสร็จ', close: 'ปิด', communityTitle: 'โพสต์ชุมชน',
        submit: 'โพสต์', photos: 'รูป', title: 'หัวข้อ', category: 'หมวด', price: 'ราคา',
        freeShare: 'แจกฟรี', body: 'รายละเอียด', bodyPlaceholder: 'ซื้อขายกับเพื่อนบ้านใกล้ๆ',
        regionLine: 'พื้นที่ซื้อขาย', regionArea: 'พื้นที่', communityBodyPh: 'แชร์เคล็ดลับใกล้บ้าน',
        optionalPhoto: 'รูป (ไม่บังคับ)', regionUnset: 'ยังไม่ตั้ง', regionAll: 'ทุกพื้นที่',
        titlePlaceholder: 'ใส่หัวข้อ', pricePlaceholder: 'ใส่ราคา', saving: 'กำลังโพสต์…',
        saved: 'บันทึกแล้ว', saveFailed: 'บันทึกไม่สำเร็จ', needTitle: 'กรุณาใส่หัวข้อ',
        needTitleBody: 'กรุณาใส่หัวข้อและเนื้อหา', submitCta: 'ลงประกาศ', justNow: 'เมื่อสักครู่',
        imageOptimizing: 'กำลังปรับรูป…',
      },
      jobs: {
        title: 'งาน', tabHire: 'รับสมัคร', tabSeek: 'หางาน', writeFab: 'เขียน',
        writeHire: 'ลงรับสมัคร', writeSeek: 'ลงโปรไฟล์หางาน', needTitle: 'กรุณาใส่หัวข้อ',
        saved: 'โพสต์แล้ว', fieldTitle: 'หัวข้อ / บริษัทหรือชื่อเล่น', fieldSalary: 'เงินเดือน',
        fieldRegion: 'พื้นที่', fieldExtra: 'รายละเอียด', fieldContact: 'ติดต่อ',
      },
      notificationCenter: {
        title: 'การแจ้งเตือน', markAll: 'อ่านทั้งหมด', unread: 'ยังไม่อ่าน',
        loading: 'กำลังโหลดการแจ้งเตือน…', emptyRemote: 'ยังไม่มีการแจ้งเตือน',
      },
      share: { open: 'แชร์', system: 'แชร์ผ่าน…', copy: 'คัดลอกลิงก์', copied: 'คัดลอกลิงก์แล้ว', copyFailed: 'คัดลอกไม่ได้' },
      creator: {
        pageTitle: 'ครีเอเตอร์',
        onboarding: {
          title: 'สมัครครีเอเตอร์',
          desc: 'สร้างคอนเทนต์พาคนมาที่ร้าน รับค่าคอมต่อครั้งที่มา',
          nameLabel: 'ชื่อที่ใช้', namePlaceholder: 'ชื่อเล่น / ช่อง', nameRequired: 'กรุณาใส่ชื่อ',
          prefillNote: 'ดึงจากโปรไฟล์แล้ว แก้ได้ตามต้องการ', refetchBtn: 'โหลดจากโปรไฟล์อีกครั้ง',
          bioLabel: 'แนะนำตัว', bioPlaceholder: 'แนะนำสั้นๆ', typeLabel: 'ประเภทคอนเทนต์',
          cityLabel: 'เมือง', followerLabel: 'ผู้ติดตาม', submitBtn: 'สมัคร',
          submitted: 'รับสมัครแล้ว จะแจ้งหลังตรวจ', submitFail: 'สมัครไม่สำเร็จ',
          type: { video: 'วิดีโอ', photo: 'รูป', blog: 'บล็อก', mixed: 'ผสม' },
        },
        pending: { title: 'กำลังตรวจ', desc: 'กำลังตรวจใบสมัคร จะแจ้งเมื่ออนุมัติ' },
        qrLanding: {
          notFound: 'ลิงก์ไม่ถูกต้อง', genericError: 'เกิดข้อผิดพลาด ลองใหม่',
          viaCreator: 'มาจากคำแนะนำของ {name}', showStaffHint: 'โชว์หน้าจอนี้ให้พนักงาน',
        },
      },
    },
  ),
  id: pack(
    {
      catalogDetail: {
        main: {
          pageTitle: 'Produk',
          notFoundTitle: 'Produk tidak ditemukan',
          notFoundHint: 'Mungkin belum dipublikasikan atau bersifat privat.',
          paidConfirmedToast: 'Pembayaran {mode} selesai. Pemesanan terkirim.',
          durationHoursFormat: '{hours} jam',
          previewBanner: 'Pratinjau belum terbit — pelanggan belum melihatnya.',
          noPackageAvailable: 'Tidak ada paket yang bisa dipesan. Hubungi lewat obrolan.',
          requestSentToast: 'Permintaan pemesanan terkirim. Dikonfirmasi setelah chat dengan mitra.',
          instantBookBadge: 'Konfirmasi instan',
          partnerConfirmBadge: 'Konfirmasi mitra',
          pickupBadge: 'Jemputan',
          freeCancelBadge: 'Batal gratis',
          noRefundBadge: 'Tidak dapat dibatalkan',
          discountSectionTitle: 'Diskon',
          priceFromTo: 'Harga {list} → Diskon {base}',
          discountAppliedLabel: 'Diskon {rate}%',
          serviceInfoTitle: 'Info layanan',
          durationLabel: 'Durasi: {duration}',
          comboSectionTitle: '🎁 Paket combo',
          comboTotalDuration: 'Total durasi: {duration}',
          descriptionTitle: 'Detail',
          businessInfoTitle: 'Tentang mitra',
          businessInfoHint: 'Chat langsung lewat tombol di bawah.',
          businessFallback: 'Bisnis',
          labelPreview: 'Bisa dipesan setelah terbit',
          labelConsult: 'Minta konsultasi',
          labelBook: 'Pesan sekarang',
          menuFallback: 'Menu',
        },
        reviews: {
          sectionTitle: 'Ulasan',
          empty: 'Belum ada ulasan',
          countSuffix: '{count} ulasan',
          loadMore: 'Lihat ulasan lain',
          anonymous: 'Anonim',
        },
      },
      bookingSheet: {
        title: 'Pesan',
        dateLabel: 'Tanggal',
        dateListAria: 'Tanggal pemesanan',
        timeLabel: 'Waktu',
        noTimeSlotHint: 'Tidak ada slot di tanggal ini. Pilih tanggal lain.',
        timeDiscountFallback: 'Diskon jam',
        timeDiscountBadge: '🔥 {label} · diskon {percent}%',
        adultsLabel: 'Dewasa',
        childrenLabel: 'Anak',
        totalLabel: 'Total',
        payMethodLabel: 'Metode bayar',
        depositLabel: 'Deposit',
        fullLabel: 'Penuh',
        requestWithoutPayBtn: 'Kirim tanpa bayar',
        processingLabel: 'Memproses…',
        requestBtn: 'Kirim pemesanan',
        closeBtn: 'Tutup',
        selectTimeToast: 'Pilih waktu.',
        slotsLeft: 'Sisa {count} kursi',
        almostFull: 'Hampir penuh',
        cardInfoLabel: 'Info kartu',
        testCardHint: 'Uji: sukses 4242… · gagal 4000…',
        payBtn: 'Bayar {label}',
        payProcessing: 'Memproses pembayaran…',
        stripeLoading: 'Memuat sistem bayar. Coba lagi sebentar.',
        bookingFailToast: 'Gagal mengirim pemesanan.',
        noPaymentServer: 'Server pembayaran tidak terhubung.',
        loginRequired: 'Perlu masuk.',
        payPrepFail: 'Gagal menyiapkan pembayaran.',
        cardPayFail: 'Pembayaran kartu gagal.',
        payNotCompleted: 'Pembayaran belum selesai.',
        payError: 'Terjadi kesalahan saat bayar.',
      },
      bookingBar: { chatInquiry: 'Tanya via obrolan', consultRequest: 'Minta konsultasi' },
    },
    {
      search: {
        placeholder: 'Cari listing, posting, dan lowongan',
        hint: 'Cari pasar, komunitas, dan lowongan sekaligus.',
        empty: 'Tidak ada hasil.',
        products: 'Pasar',
        posts: 'Komunitas',
        jobs: 'Lowongan',
        tabAll: 'Semua',
        tabProducts: 'Listing',
        tabPosts: 'Posting',
        tabJobs: 'Lowongan',
        jobHireBadge: 'Rekrut',
        jobSeekBadge: 'Cari kerja',
        jobsMoreInTab: 'Buka tab Lowongan untuk lebih banyak',
        recentTitle: 'Pencarian terbaru',
        popularTitle: 'Populer',
      },
      productDetail: {
        back: 'Kembali', more: 'Lainnya', mannerTemp: 'Skor sopan', chat: 'Obrolan',
        chatNoSeller: 'Chat hanya untuk listing anggota.', chatOwnProduct: 'Ini listing Anda.',
        chatOpenFailed: 'Tidak bisa mulai chat.', reportScam: 'Laporkan penipuan',
        like: 'Suka', likeOn: 'Batal suka', likeOff: 'Suka', sliderLabel: 'Foto produk',
        views: '{count} tayangan', safePaymentSoon: 'Pembayaran in-app segera',
      },
      postDetail: {
        back: 'Kembali', more: 'Lainnya', report: 'Laporkan', comments: 'Komentar',
        commentPlaceholder: 'Tulis komentar…', post: 'Kirim', likes: 'Suka',
        likeOn: 'Batal suka', likeOff: 'Suka', commentEmpty: 'Isi komentar.',
        commentSent: 'Komentar terkirim.', translate: 'Terjemahkan', showOriginal: 'Tampilkan asli',
        translateFailed: 'Tidak bisa menerjemahkan.', translateBusy: 'Menerjemahkan…',
      },
      write: {
        tradeTitle: 'Listing baru', done: 'Selesai', close: 'Tutup', communityTitle: 'Posting tetangga',
        submit: 'Kirim', photos: 'Foto', title: 'Judul', category: 'Kategori', price: 'Harga',
        freeShare: 'Gratis', body: 'Deskripsi', bodyPlaceholder: 'Jual-beli dengan tetangga dekat',
        regionLine: 'Area transaksi', regionArea: 'Wilayah', communityBodyPh: 'Bagikan tips tetangga',
        optionalPhoto: 'Foto (opsional)', regionUnset: 'Belum diatur', regionAll: 'Semua wilayah',
        titlePlaceholder: 'Masukkan judul', pricePlaceholder: 'Masukkan harga', saving: 'Mengirim…',
        saved: 'Tersimpan.', saveFailed: 'Gagal menyimpan.', needTitle: 'Masukkan judul.',
        needTitleBody: 'Masukkan judul dan isi.', submitCta: 'Pasang listing', justNow: 'Baru saja',
        imageOptimizing: 'Mengoptimalkan gambar…',
      },
      jobs: {
        title: 'Lowongan', tabHire: 'Rekrut', tabSeek: 'Cari kerja', writeFab: 'Tulis',
        writeHire: 'Pasang lowongan', writeSeek: 'Pasang profil', needTitle: 'Masukkan judul.',
        saved: 'Terkirim.', fieldTitle: 'Judul / perusahaan atau nama', fieldSalary: 'Gaji',
        fieldRegion: 'Wilayah', fieldExtra: 'Detail', fieldContact: 'Kontak',
      },
      notificationCenter: {
        title: 'Notifikasi', markAll: 'Tandai semua dibaca', unread: 'Belum dibaca',
        loading: 'Memuat notifikasi…', emptyRemote: 'Belum ada notifikasi.',
      },
      share: { open: 'Bagikan', system: 'Bagikan via…', copy: 'Salin tautan', copied: 'Tautan disalin.', copyFailed: 'Gagal menyalin.' },
      creator: {
        pageTitle: 'Kreator',
        onboarding: {
          title: 'Daftar jadi kreator',
          desc: 'Buat konten yang membawa kunjungan dan dapat komisi per kunjungan.',
          nameLabel: 'Nama tampilan', namePlaceholder: 'Nama / channel', nameRequired: 'Masukkan nama.',
          prefillNote: 'Diisi dari profil. Silakan edit.', refetchBtn: 'Muat ulang dari profil',
          bioLabel: 'Bio', bioPlaceholder: 'Pengantar singkat', typeLabel: 'Jenis konten',
          cityLabel: 'Kota', followerLabel: 'Pengikut', submitBtn: 'Kirim',
          submitted: 'Pendaftaran terkirim. Kami akan meninjau.', submitFail: 'Gagal mengirim.',
          type: { video: 'Video', photo: 'Foto', blog: 'Blog', mixed: 'Campuran' },
        },
        pending: { title: 'Sedang ditinjau', desc: 'Pendaftaran kreator sedang dicek. Kami beri tahu jika disetujui.' },
        qrLanding: {
          notFound: 'Tautan tidak valid.', genericError: 'Terjadi kesalahan. Coba lagi.',
          viaCreator: 'Anda datang lewat {name}', showStaffHint: 'Tunjukkan layar ini ke staf',
        },
      },
    },
  ),
};

export function getUserFacingOverlay(lang) {
  return USER_FACING_UI[lang] || {};
}
